module.exports = __webpack_public_path__ + "img/23.b1bd7635.png";